import { Button, Select } from "antd";
import styled from "styled-components";

export const UserTableWrapper = styled.div`
  position: relative;
  .table-row-data {
    .ant-table-tbody > tr > td {
      cursor: pointer;
      border-bottom: 1px solid #c0c1c2 !important;
    }
    .ant-empty-description {
      visibility: hidden;
    }
    .ant-empty-description:after {
      visibility: visible;
      display: block;
      margin-top: -25px;
    }
    .table-striped-rows tr {
      background-color: #fbfbfb;
      height: 57px;
    }

    .ant-table-thead > tr > th {
      background: #0089cf;
      color: white;
      position: sticky;
      top: 110px;
      z-index: 2;
      ::before {
        /* display: none; */
      }
    }

    .action-row {
      display: flex;
      justify-content: flex-end;
      img {
        margin-right: 10px;
        cursor: pointer;
      }
    }
  }
  .visible {
    table {
      visibility: hidden;
    }
  }
`;
export const IconWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  img {
    margin-right: 10px;
    cursor: pointer;
  }
`;
export const EditUserWrapper = styled.div`
  margin-top: -20px;
`;
export const ButtonWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
export const ButtonCancel = styled(Button)`
  width: 48%;
  height: 40px;
  background-color: #bdc3c7;
`;
export const ButtonSave = styled(Button)`
  width: 48%;
  height: 40px;
  background-color: #bdc3c7;
`;
export const BtnAddUser = styled(Button)`
  background-color: #0089cf;
  color: white;
  border-radius: 7px;
  align-items: right;
`;
export const ContainerBtn = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
  padding-bottom: 20px;
`;
export const SelectedCity = styled(Select)`
  width: 100%;
`;
